/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { getUserInitials } from '@e180/domain/lib/user/util';

import styles from './DefaultUserAvatar.style';

import {
  xsmall,
  small,
  medium,
  large,
  xlarge,
  xxlarge,
} from 'src/shared/ui/component/image/setting/avatarVariants';

import type { User } from '@e180/domain/lib/user/type';
import type { AvatarProps } from 'src/shared/ui/component/image/type/avatarTypes';

type Props = AvatarProps & {
  user: User,
};

const useStyles = createUseStyles(styles);

const DefaultUserAvatar = ({
  layoutClass,
  variant,
  alt,
  user,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  const rootClasses = classNames(classes.root, layoutClass, {
    [`${classes['root-xsmall']}`]: variant === xsmall,
    [`${classes['root-small']}`]: variant === small,
    [`${classes['root-medium']}`]: variant === medium,
    [`${classes['root-large']}`]: variant === large,
    [`${classes['root-xlarge']}`]: variant === xlarge,
    [`${classes['root-xxlarge']}`]: variant === xxlarge,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={rootClasses} aria-label={alt} aria-hidden={!alt}>
      {getUserInitials(user)}
    </div>
  );
};

// Make variants available
export * from 'src/shared/ui/component/image/setting/avatarVariants';

export default compose(React.memo)(DefaultUserAvatar);
